// Aquí está el slice de usuario
import { createSlice } from "@reduxjs/toolkit";
import { updateImgPerfil } from "./userThunks";

const initialState = {
  info: null,
  ticketsComprados: null,
  ticketDetalle: null,
  failureUser: false,
  error: null,
  errorStatus: null,
  isLoading: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userSuccess: (state, action) => {
      if (action.payload.info !== undefined) {
        state.info = action.payload.info;
      }
      if (action.payload.ticketDetalle !== undefined) {
        state.ticketDetalle = action.payload.ticketDetalle;
      }
      state.failureUser = false;
      state.error = null;
      state.errorStatus = null;
      state.isLoading = false;
    },
    userFailure: (state, action) => {
      state.failureUser = true;
      state.isLoading = false;
      // Soportar tanto string como objeto { message, status }
      if (typeof action.payload === 'string') {
        state.error = action.payload;
        state.errorStatus = null;
      } else {
        state.error = action.payload?.message || action.payload;
        state.errorStatus = action.payload?.status || null;
      }
    },
    userReset: (state) => {
      state.info = null;
      state.ticketsComprados = null;
      state.ticketDetalle = null;
      state.failureUser = false;
      state.error = null;
      state.errorStatus = null;
      state.isLoading = false;
    },
  },
});


export const {
  userSuccess,
  userFailure,
  userReset,
} = userSlice.actions;
export default userSlice.reducer;
